import { useQuery, useMutation, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import { customApi } from "../../../../CustomHoock/CustomApi";
import { getOrderTotalR } from "../../../../General/Store/GeneralSlice";
import { setReportListFooterR } from "../ReportListSlice/ReportListSlice";

const useGetOrderSearchDTO = () => {
  return useQuery(
    ["GetOrderSearchDTO"],
    () =>
      customApi({
        apiType: "get",
        url: "/api/v1/ReportList/GetOrderSearchDTO",
        reactQuery: "query",
      }),
    {
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      onError: () => {},
      select: (data) => {
        let res = data?.data.data;
        return res;
      },
    }
  );
};
const useGetOrderReport = (requestBody, apiProps) => {
  const dispatch = useDispatch();
  let totalRecord;
  const body = { ...requestBody, ...apiProps.reportDTO, getExcel: true };
  return useQuery(
    ["GetOrderSearchDTO", requestBody, apiProps],
    () =>
      customApi({
        apiType: "post",
        url: "/api/v1/ReportList/GetOrderReport",
        reactQuery: "query",
        requestBody: body,
      }),
    {
      enabled: !!body,
      refetchOnWindowFocus: false,

      onError: () => {},
      select: (data) => {
        totalRecord = data?.data.data.totalRecords; //for pagnation
        let res = data?.data.data.items;
        const footer = data?.data.data.fotter;
        dispatch(setReportListFooterR(footer));
        dispatch(getOrderTotalR(totalRecord));
        return res;
      },
    }
  );
};
/*================================ Invoice ==============================*/
const useGetInvoiceSearchDTO = () => {
  return useQuery(
    ["GetInvoiceSearchDTO"],
    () =>
      customApi({
        apiType: "get",
        url: "/api/v1/ReportList/GetInvoiceSearchDTO",
        reactQuery: "query",
      }),
    {
      //enabled: true,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      onError: () => {},
      select: (data) => {
        let res = data?.data.data;
        return res;
      },
    }
  );
};
const useGetInvoiceReport = (requestBody, apiProps) => {
  const dispatch = useDispatch();
  let totalRecord;
  const body = { ...requestBody, ...apiProps.reportDTO };
  return useQuery(
    ["GetOrderSearchDTO", requestBody, apiProps],
    () =>
      customApi({
        apiType: "post",
        url: "/api/v1/ReportList/GetInvoiceReport",
        reactQuery: "query",
        requestBody: body,
      }),
    {
      enabled: !!body,
      refetchOnWindowFocus: false,

      onError: () => {},
      select: (data) => {
        totalRecord = data?.data.data.totalRecords; //for pagnation
        dispatch(getOrderTotalR(totalRecord));
        const footer = data?.data.data.fotter;
        let res = data?.data.data.items;
        dispatch(setReportListFooterR(footer));
        return res;
      },
    }
  );
};
/*================================ Pre-invoice ==============================*/
const useGetProformaInvoiceSearchDTO = () => {
  return useQuery(
    ["GetProformaInvoiceSearchDTO"],
    () =>
      customApi({
        apiType: "get",
        url: "/api/v1/ReportList/GetProformaInvoiceSearchDTO",
        reactQuery: "query",
      }),
    {
      //enabled: true,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      onError: () => {},
      select: (data) => {
        let res = data?.data.data;
        return res;
      },
    }
  );
};
const useGetProformaInvoiceReport = (requestBody, apiProps) => {
  const dispatch = useDispatch();
  let totalRecord;
  const body = { ...requestBody, ...apiProps.reportDTO };
  return useQuery(
    ["GetProformaInvoiceReport", requestBody, apiProps],
    () =>
      customApi({
        apiType: "post",
        url: "/api/v1/ReportList/GetProformaInvoiceReport",
        reactQuery: "query",
        requestBody: body,
      }),
    {
      enabled: !!body,
      refetchOnWindowFocus: false,
      onSuccess: () => {
        dispatch(getOrderTotalR(totalRecord));
      },
      onError: () => {},
      select: (data) => {
        totalRecord = data?.data.data.totalRecords; //for pagnation
        const footer = data?.data.data.fotter;
        let res = data?.data.data.items;
        dispatch(setReportListFooterR(footer));
        return res;
      },
    }
  );
};
/*================================ Device ==============================*/
const useGetProductionDeviceSearchDTO = () => {
  return useQuery(
    ["GetProductionDeviceSearchDTO"],
    () =>
      customApi({
        apiType: "get",
        url: "/api/v1/ReportList/GetProductionDeviceSearchDTO",
        reactQuery: "query",
      }),
    {
      refetchOnWindowFocus: false,
      onError: () => {},
      select: (data) => {
        let res = data?.data.data;
        return res;
      },
    }
  );
};
const useGetProductionDeviceReport = (requestBody, apiProps) => {
  const dispatch = useDispatch();
  let totalRecord;
  const body = { ...requestBody, ...apiProps.reportDTO };
  return useQuery(
    ["GetOrderSearchDTO", requestBody, apiProps],
    () =>
      customApi({
        apiType: "post",
        url: "/api/v1/ReportList/GetProductionDeviceReport",
        reactQuery: "query",
        requestBody: body,
      }),
    {
      enabled: !!body,
      refetchOnWindowFocus: false,
      onSuccess: () => {
        dispatch(getOrderTotalR(totalRecord));
      },
      onError: () => {},
      select: (data) => {
        totalRecord = data?.data.data.totalRecords; //for pagnation
        const footer = data?.data.data.fotter;
        let res = data?.data.data.items;
        dispatch(setReportListFooterR(footer));
        return res;
      },
    }
  );
};

const useGetPersonLeaveSearchDTO = () => {
  return useQuery(
    ["GetPersonLeaveSearchDTO"],
    () =>
      customApi({
        apiType: "get",
        url: "/api/v1/ReportList/GetPersonLeaveSearchDTO",
        reactQuery: "query",
      }),
    {
      //enabled: true,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      onError: () => {},
      select: (data) => {
        let res = data?.data.data;
        return res;
      },
    }
  );
};
const useGetPersonLeaveReport = (requestBody, apiProps) => {
  const dispatch = useDispatch();
  let totalRecord;
  const body = apiProps.reportDTO
    ? { ...requestBody, ...apiProps.reportDTO }
    : null;
  return useQuery(
    ["GetOrderSearchDTO", requestBody, apiProps],
    () =>
      customApi({
        apiType: "post",
        url: "/api/v1/ReportList/GetPersonLeaveReport",
        reactQuery: "query",
        requestBody: body,
      }),
    {
      enabled: !!body,
      refetchOnWindowFocus: false,
      onSuccess: () => {
        dispatch(getOrderTotalR(totalRecord));
      },
      onError: () => {},
      select: (data) => {
        totalRecord = data?.data?.totalRecord; //for pagnation
        let res = data?.data.data;
        //const footer = data?.data.data.fotter;
        // dispatch(setReportListFooterR(footer));
        return res;
      },
    }
  );
};
export const useGetAllLeaveRequestWithTotal = (requestBody, apiProps) => {
  const dispatch = useDispatch();
  let totalRecord;
  const body = { ...requestBody, ...apiProps.reportDTO };
  return useQuery(
    ["GetAllLeaveRequestWithTotal", body],
    () =>
      customApi({
        apiType: "post",
        url: "/api/v1/ReportList/GetLeaveRequestReport",
        reactQuery: "query",
        requestBody: body,
      }),
    {
      enabled: !!body,
      refetchOnWindowFocus: false,
      onSuccess: () => {
        dispatch(getOrderTotalR(totalRecord));
      },
      onError: () => {},
      select: (data) => {
        totalRecord = data?.data?.totalRecord; //for pagnation
        let res = data?.data.data;
        //const footer = data?.data.data.fotter;
        // dispatch(setReportListFooterR(footer));
        return res;
      },
    }
  );
};

/*================================ GetListResult ==============================*/
const useGetListResult = () => {
  const body = {
    Title: "TestReport",
    ChartType: "List",
    TableFullName: "Rasam.Entities.Models.Rasam.OrderRegistration.Rasam_Order",
    CategoryId: "33a3d221-3e86-ef11-b620-a036bc26c046",
    SelectedFields: [
      {
        Title: "نام خانوادگی طراح",
        Field: "Designer.Person.LastName",
      },
      {
        Title: "نام طراح",
        Field: "Designer.Person.FirstName",
      },
      {
        Title: "نام سفارش",
        Field: "OrderName",
      },
      {
        Title: "تاریخ ایجاد",
        Field: "CreateDate",
      },
      {
        Title: "مرحله کنونی",
        Field: "CurrentStep.StepName",
      },
      {
        Title: "نام خانوادگی ایجاد کننده",
        Field: "CreateBy.Person.LastName",
      },
      {
        Title: "نوع سفارش",
        Field: "OrderType",
      },
    ],
    MainCondition: {
      GroupConditionType: "And",
      GroupConditions: [],
      Conditions: [
        {
          FieldName: "Designer.Person.FirstName",
          CompareType: "Equal",
          Value: "سیدسعید",
        },
      ],
    },
  };
  return useQuery(
    ["GetListResult", body],
    () =>
      customApi({
        apiType: "post",
        url: "/api/v1/ReportList/GetListResult",
        reactQuery: "query",
        requestBody: body,
      }),
    {
      enabled: !!body,
      refetchOnWindowFocus: false,
      onSuccess: () => {
        // dispatch(getOrderTotalR(totalRecord));
      },
      onError: () => {},
      select: (data) => {
        //totalRecord = data?.data.data.totalRecords; //for pagnation
        let res = data?.data.data;
        //dispatch(setReportListFooterR(footer));
        return res;
      },
    }
  );
};

export {
  useGetOrderSearchDTO,
  useGetOrderReport,
  useGetInvoiceSearchDTO,
  useGetInvoiceReport,
  useGetProformaInvoiceSearchDTO,
  useGetProformaInvoiceReport,
  useGetProductionDeviceSearchDTO,
  useGetProductionDeviceReport,
  useGetListResult,
  useGetPersonLeaveSearchDTO,
  useGetPersonLeaveReport,
};
